import {
  collection,
  addDoc,
  /* updateDoc, */
  deleteDoc,
  doc,
  query,
  where,
  getDocs,
  orderBy,
  Timestamp,
  setDoc
} from 'firebase/firestore';
import { db } from '../../config/firebase';
import { Analysis, Role } from '../../types';

// Analyses
export const saveAnalysis = async (analysis: Omit<Analysis, 'id'>): Promise<string> => {
  try {
    const docRef = await addDoc(collection(db, 'analyses'), {
      ...analysis,
      createdAt: Timestamp.fromDate(new Date())
    });
    return docRef.id;
  } catch (error: any) {
    console.error('Error saving analysis:', error);
    throw new Error('Failed to save analysis');
  }
};

export const getUserAnalyses = async (userId: string): Promise<Analysis[]> => {
  try {
    const analysesRef = collection(db, 'analyses');
    const q = query(
      analysesRef,
      where('userId', '==', userId),
      orderBy('createdAt', 'desc')
    );

    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      createdAt: doc.data().createdAt.toDate()
    })) as Analysis[];
  } catch (error: any) {
    console.error('Error fetching analyses:', error);
    // If the error is due to missing index, return unordered results
    if (error.code === 'failed-precondition') {
      const basicQuery = query(
        collection(db, 'analyses'),
        where('userId', '==', userId)
      );
      const snapshot = await getDocs(basicQuery);
      const analyses = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
        createdAt: doc.data().createdAt.toDate()
      })) as Analysis[];

      return analyses.sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime());
    }
    throw error;
  }
};

export const deleteAnalysis = async (id: string): Promise<void> => {
  try {
    await deleteDoc(doc(db, 'analyses', id));
  } catch (error: any) {
    console.error('Error deleting analysis:', error);
    throw new Error('Failed to delete analysis');
  }
};

// Roles
export const saveRole = async (role: Omit<Role, 'id'>): Promise<string> => {
  try {
    const docRef = await addDoc(collection(db, 'roles'), role);
    return docRef.id;
  } catch (error: any) {
    console.error('Error saving role:', error);
    throw new Error('Failed to save role');
  }
};

export const updateRole = async (id: string, role: Partial<Role>): Promise<void> => {
  try {
    const roleRef = doc(db, 'roles', id);
    await setDoc(roleRef, role, { merge: true });
  } catch (error: any) {
    console.error('Error updating role:', error);
    throw new Error('Failed to update role');
  }
};

export const getRoles = async (): Promise<Role[]> => {
  try {
    const querySnapshot = await getDocs(collection(db, 'roles'));
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as Role[];
  } catch (error: any) {
    console.error('Error fetching roles:', error);
    throw new Error('Failed to fetch roles');
  }
};

export const deleteRole = async (id: string): Promise<void> => {
  try {
    await deleteDoc(doc(db, 'roles', id));
  } catch (error: any) {
    console.error('Error deleting role:', error);
    throw new Error('Failed to delete role');
  }
};
